/**
 * @file TwitterSharingButton.tsx
 *
 * @fileoverview Renders buttons for sharing on Twitter.
 */

import {
  SharingButtonProps,
  SharingButtonCustom,
} from '~/jobiqo/components/SocialMedia/SharingButtons/components/Custom';
import TwitterColorIcon from '~/vcl/icons/color/Twitter';
import { FormattedMessage } from 'react-intl';
import TwitterIcon from '~/vcl/icons/Twitter';

export default function TwitterSharingButton({
  title,
  url,
  coloredIcons = true,
  ...props
}: SharingButtonProps) {
  return (
    <SharingButtonCustom
      text={
        <FormattedMessage
          id="social_media_sharing_buttons_twitter"
          defaultMessage="on X"
        />
      }
      urlToShare={url}
      href={`https://twitter.com/intent/tweet/?text=${encodeURIComponent(
        title || '',
      )}&url=`}
      IconComponent={coloredIcons ? TwitterColorIcon : TwitterIcon}
      {...props}
    />
  );
}
export { TwitterSharingButton };
